import path from "node:path";
import { getTemplateFiles } from "./templates.js";

export interface InstallAction {
  type: "conflict" | "create";
  relativePath: string;
  absolutePath: string;
  content: string | null;
}

export interface CreateInstallPlanOptions {
  cwd: string;
  exists: (filePath: string) => Promise<boolean> | boolean;
  profile?: string;
}

export async function createInstallPlan({
  cwd,
  exists,
  profile = "standard"
}: CreateInstallPlanOptions): Promise<InstallAction[]> {
  const actions: InstallAction[] = [];
  const templateFiles = getTemplateFiles(profile);
  const installRoot = ".ai-workflow";

  for (const [relativePath, content] of Object.entries(templateFiles)) {
    if (relativePath === "opencode.jsonc") {
      continue;
    }

    const installedRelativePath = path.join(installRoot, relativePath);
    const absolutePath = path.join(cwd, installedRelativePath);
    const action = (await exists(absolutePath)) ? "conflict" : "create";
    actions.push({
      type: action,
      relativePath: installedRelativePath,
      absolutePath,
      content
    });
  }

  const configPath = path.join(cwd, ".ai-workflow/config.json");
  actions.push({
    type: (await exists(configPath)) ? "conflict" : "create",
    relativePath: ".ai-workflow/config.json",
    absolutePath: configPath,
    content: null
  });

  return actions;
}
